module.exports = __webpack_public_path__ + "img/Smile.d1e2a989.png";